export function getShamsiDate(
  gregorianDate: string | Date | number | undefined = "",
  hasTime: boolean = false,
  showSeconds: boolean = false
): string {
  const date = gregorianDate ? new Date(gregorianDate) : new Date();
  let shamsiLocale = {};
  if (hasTime) {
    shamsiLocale = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      calendar: "persian",
    };

    if (showSeconds)
      shamsiLocale = {
        ...shamsiLocale,
        second: "2-digit",
      };
  } else {
    shamsiLocale = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      calendar: "persian",
    };
  }
  const shamsiDate = date
    .toLocaleString("fa-IR-u-ca-persian", shamsiLocale)
    .replace(",", "");
  return shamsiDate;
}

export const getTodayName = () => {
  const today = new Date();
  let shamsiLocaleDate: any = {
    weekday: "long",
    calendar: "persian",
  };
  return today
    .toLocaleString("fa-IR-u-ca-persian", shamsiLocaleDate)
    .replace(",", "");
};

export function getShamsiDateHasTodayIsTime(
  gregorianDate: string | Date | number | undefined = "",
  hasTime: boolean = false
): string {
  const today = new Date();
  const date = gregorianDate ? new Date(gregorianDate) : new Date();
  let shamsiLocaleDate = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  let todayDate = today
    .toLocaleString("fa-IR-u-ca-persian", shamsiLocaleDate)
    .replace(",", "");
  let shamsiDate = date
    .toLocaleString("fa-IR-u-ca-persian", shamsiLocaleDate)
    .replace(",", "");
  if (todayDate == shamsiDate) {
    let shamsiLocaleTime = {
      hour: "2-digit",
      minute: "2-digit",
      calendar: "persian",
    };
    return date
      .toLocaleString("fa-IR-u-ca-persian", shamsiLocaleTime)
      .replace(",", "");
  } else if (hasTime) {
    shamsiLocaleDate = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      calendar: "persian",
    };
    shamsiDate = date
      .toLocaleString("fa-IR-u-ca-persian", shamsiLocaleDate)
      .replace(",", "");
    return shamsiDate;
  } else {
    return shamsiDate;
  }
}

export const convertDateToUnix = (
  dateString: string | null = null,
  endOfDay: boolean = false
) => {
  const isExist = dateString ? dateString.includes("T") : false;
  const timeSuffix = isExist ? "" : endOfDay ? "T23:59:59Z" : "T00:00:00Z";
  const date = dateString ? new Date(`${dateString}${timeSuffix}`) : new Date();
  return `${Math.floor(date.getTime() / 1000)}`;
};

export const convertUnixToDate = (
  unixTimestamp: number,
  hasTime: boolean = false,
  hasSecond: boolean = true
) => {
  const date = new Date(unixTimestamp * 1000);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  if (hasTime) {
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    const second = String(date.getSeconds()).padStart(2, "0");
    return hasSecond
      ? `${year}-${month}-${day} ${hour}:${minute}:${second}`
      : `${year}-${month}-${day} ${hour}:${minute}`;
  } else {
    return `${year}-${month}-${day}`;
  }
};

export const getDateWithAddedDays = (
  days: number = 0,
  customDate: string = ""
) => {
  const date = customDate ? new Date(customDate) : new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split("T")[0];
};

export const getDaysBetween = (end: Date, start: Date | null) => {
  const startDate = start ? new Date(start) : new Date();
  const endDate = new Date(end);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const diffTime = endDate - startDate;

  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}

export const convertSec = (
  totalSeconds: number | null,
  showSymbols: boolean = false,
  showFullText: boolean = true
): string => {
  if (
    totalSeconds === null ||
    totalSeconds === undefined ||
    totalSeconds <= 0
  ) {
    return "00:00";
  }

  let seconds = Math.floor(totalSeconds % 60);
  let minutes = Math.floor(totalSeconds / 60);
  let hours = "";

  if (minutes > 59) {
    hours = Math.floor(minutes / 60).toString();
    hours = +hours >= 10 ? hours.toString() : "0" + hours;
    minutes -= +hours * 60;
  }

  const formattedMinutes = minutes >= 10 ? minutes.toString() : "0" + minutes;
  const formattedSeconds = seconds >= 10 ? seconds.toString() : "0" + seconds;

  const minuteSymbol = showSymbols ? "’" : "";
  const secondSymbol = showSymbols ? "”" : "";

  if (hours) {
    hours = hours.length === 1 ? "0" + hours : hours;
    return `${hours}:${formattedMinutes}:${formattedSeconds}`;
  }
  return `${formattedMinutes}${minutes ? minuteSymbol : ""
    }:${formattedSeconds}${secondSymbol}`;
};

export const convertFullSec = (totalSeconds: number) => {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours >= 10 ? hours : "0" + hours}:${minutes >= 10 ? minutes : "0" + minutes
    }:${seconds >= 10 ? seconds : "0" + seconds}`;
};

export const getDurationFromNow = (dateString: string) => {
  const givenDate = new Date(dateString);
  const now = new Date();
  const diff = now - givenDate;
  const seconds = Math.floor((diff / 1000) % 60);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  let duration;

  if (days > 0) {
    duration = `${days} روز, ${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  } else if (hours > 0) {
    duration = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  } else if (minutes > 0) {
    duration = `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  } else {
    duration = `00:${seconds}`;
  }
  return duration;
};

export const timeToSeconds = (timeStr: string): number | null => {
  const regex = /^(\d+)(d|h|m|s)$/i;
  const match = timeStr.match(regex);

  if (!match) return null;

  const value = parseInt(match[1], 10);
  const unit = match[2].toLowerCase();

  switch (unit) {
    case "d":
      return value * 86400;
    case "h":
      return value * 3600;
    case "m":
      return value * 60;
    case "s":
      return value;
    default:
      return null;
  }
}

export const isoDate = (dateTime: string) => {
  let [dateStr, timeStr] = dateTime.split(" ");
  const date = `${dateStr}T${timeStr}:00`
  return date;
}